export default "__VITE_ASSET__$hBOS4Yu__"